import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../LanguageSwitcher';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShieldAlt, faBars, faTimes } from '@fortawesome/free-solid-svg-icons';

const Header = () => {
  const { t } = useTranslation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const navItems = [
    { label: 'Protocol', href: '/protocol' },
    { label: 'Technology', href: '/technology' },
    { label: 'Community', href: '/community' },
    { label: 'Ecosystem', href: '/ecosystem' },
    { label: 'Developers', href: '/developers' }
  ];

  return (
    <header>
      <nav className="sticky top-0 z-50 bg-white/95 dark:bg-gray-900/95 backdrop-blur-md border-b border-gray-200 dark:border-gray-700">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex items-center justify-between h-16">
            {/* Logo */}
            <Link to="/" className="flex items-center space-x-3">
              <img src="/images-optimized/Logo.webp" alt="Titron Logo" className="h-10 w-auto object-contain" />
              <span className="font-bold text-xl text-gray-900 dark:text-white hidden sm:block">Titron</span>
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-8">
              {navItems.map((item, index) => (
                <Link
                  key={index}
                  to={item.href}
                  className="text-gray-700 dark:text-gray-300 hover:text-teal-600 dark:hover:text-teal-400 font-medium transition-colors"
                >
                  {item.label}
                </Link>
              ))}
            </div>

            {/* Right Side Actions */}
            <div className="flex items-center space-x-4">
              {/* Language Switcher */}
              <LanguageSwitcher />

              {/* Theme Toggle */}
              <button
                onClick={() => {
                  const htmlElement = document.documentElement;
                  const current = htmlElement.classList.contains('dark');
                  if (current) {
                    htmlElement.classList.remove('dark');
                    localStorage.setItem('darkMode', 'false');
                  } else {
                    htmlElement.classList.add('dark');
                    localStorage.setItem('darkMode', 'true');
                  }
                }}
                className="flex items-center space-x-2 text-gray-600 dark:text-gray-300 hover:text-teal-600 dark:hover:text-teal-400 transition-colors"
              >
                <i className="ri-sun-line dark:hidden"></i>
                <i className="ri-moon-line hidden dark:block"></i>
                <span className="text-sm">Theme</span>
              </button>

              {/* Mobile Menu Button */}
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="md:hidden p-2 text-gray-600 hover:text-teal-600 transition-colors"
              >
                {isMenuOpen
                  ? <FontAwesomeIcon icon={faTimes} className="text-xl" />
                  : <FontAwesomeIcon icon={faBars} className="text-xl" />
                }
              </button>
            </div>
          </div>

          {/* Mobile Menu */}
          {isMenuOpen && (
            <div className="md:hidden border-t border-gray-200 dark:border-gray-700 py-4">
              <div className="flex flex-col space-y-4">
                {navItems.map((item, index) => (
                  <Link
                    key={index}
                    to={item.href}
                    className="text-gray-700 dark:text-gray-300 hover:text-teal-600 dark:hover:text-teal-400 font-medium transition-colors px-2 py-1"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    {item.label}
                  </Link>
                ))}
                <div className="flex items-center justify-between pt-4 border-t border-gray-200 dark:border-gray-700">
                  <LanguageSwitcher />
                </div>
              </div>
            </div>
          )}
        </div>
      </nav>
    </header>
  );
};

export default Header;